module.exports = __webpack_public_path__ + "img/product_shiseido_2@2x.14ef65e0.png";